import { sha256 } from "@noble/hashes/sha2";

/** Same colour as Go gateway.ColorFor: hue from sha256(id)[0], S = 0.6, L = 0.5, channels truncated. */
export function colorFor(accountId: string): number {
  const h = (sha256(new TextEncoder().encode(accountId))[0]! / 255) * 360;
  const c = (1 - Math.abs(2 * 0.5 - 1)) * 0.6;
  const x = c * (1 - Math.abs(((h / 60) % 2) - 1));
  const m = 0.5 - c / 2;
  let r = 0, g = 0, b = 0;
  if (h < 60) [r, g, b] = [c, x, 0];
  else if (h < 120) [r, g, b] = [x, c, 0];
  else if (h < 180) [r, g, b] = [0, c, x];
  else if (h < 240) [r, g, b] = [0, x, c];
  else if (h < 300) [r, g, b] = [x, 0, c];
  else [r, g, b] = [c, 0, x];
  const ch = (v: number) => Math.trunc((v + m) * 255);
  return (ch(r) << 16) | (ch(g) << 8) | ch(b);
}

export function hexColor(n: number): string {
  return "#" + n.toString(16).padStart(6, "0");
}
